import React, { useState } from "react";
import { CircleButtonWithContent } from "./circleButtonWithContent";
import { RepaymentsDecrease } from "../../../components/icons";
import { ManageMyRepaymentModal } from "./manageMyRepaymentModal";
import { Wrapper } from "../components/manageMyRepaymentModal/manageMyRepaymentModal.styles";
import { TextButtonModal } from "../components/manageMyRepaymentModal/textButtonModal";
import { useTheme } from "styled-components";
import environmentSettings from "@constants/environmentSettings";
import { useMagicBlocksAvailable } from "@utils/helpers/useMagicBlocksAvailable";

const ModalMessage = () => {
  const { phone, email } = environmentSettings;
  const showChatToUsOnlineButton = useMagicBlocksAvailable();

  const startChat = () => {
    document.getElementsByTagName('magicblocks-widget')[0].setAttribute('open', true);
  };

  return (
    <Wrapper>
      Please call&nbsp;<a href={`tel:${phone}`}>{phone}</a>&nbsp;or email&nbsp;
      <a href={`mailto:${email}`}>{email}</a>&nbsp;to discuss.
      {showChatToUsOnlineButton && (
        <>
          &nbsp;Alternatively you can&nbsp;
          <TextButtonModal onClick={startChat}>
            chat to us online
          </TextButtonModal>
          .
        </>
      )}
    </Wrapper>
  );
};

export const ManageMyRepayments = () => {
  const theme = useTheme();

  const [showModal, setShowModal] = useState(false);

  const clickDecreaseRepayments = () => {
    setShowModal(true);
  };

  return (
    <>
      <CircleButtonWithContent
        variant="goodAlt"
        onClick={clickDecreaseRepayments}
      >
        <RepaymentsDecrease
          themeColor={theme.palette.main.white}
          width="90px"
        />
        <span>Decrease</span>
        <span>My Repayments</span>
      </CircleButtonWithContent>
      <ManageMyRepaymentModal
        visible={showModal}
        close={() => setShowModal(false)}
        header="Decrease My Repayments"
      >
        <ModalMessage />
      </ManageMyRepaymentModal>
    </>
  );
};
